import { createFeature, createReducer, on } from '@ngrx/store';
import { AuthState } from '../../../core/models/auth.model';
import { readStoredSession } from '../../../core/utils/auth-session-storage';
import { AuthActions } from './auth.actions';

const initialState: AuthState = {
  token: null,
  refreshToken: null,
  userName: null,
  role: null,
  publicId: null,
  status: null,
  loading: false,
  error: null,
  userType: null,
  roles: [],
  permissions: [],
  permissionsLoaded: false,
};

export const authFeature = createFeature({
  name: 'auth',
  reducer: createReducer(
    initialState,
    on(AuthActions.login, () => ({
      ...initialState,
      loading: true,
    })),
    on(
      AuthActions.loginSuccess,
      (state, { token, refreshToken, userName, role, publicId, status }) => ({
        ...state,
        token,
        refreshToken,
        userName,
        role,
        publicId,
        status,
        loading: false,
        error: null,
      }),
    ),
    on(AuthActions.loginFailure, (state, { error }) => ({ ...state, loading: false, error })),
    on(AuthActions.statusRefreshed, (state, { status }) => ({ ...state, status })),
    on(AuthActions.permissionsLoaded, (state, { userType, roles, permissions }) => ({
      ...state,
      userType,
      roles,
      permissions,
      permissionsLoaded: true,
    })),
    // Failure to load permissions degrades quietly: keep whatever was
    // previously known instead of surfacing an error state.
    on(AuthActions.permissionsLoadFailure, (state) => ({ ...state, permissionsLoaded: true })),
    on(AuthActions.logout, () => initialState),
    on(AuthActions.tokensRenewed, (state, { token, refreshToken }) => ({
      ...state,
      token,
      refreshToken,
    })),
    on(AuthActions.sessionExpired, () => initialState),
    on(AuthActions.sessionEndedElsewhere, () => initialState),
    on(AuthActions.init, (state) => {
      const stored = readStoredSession();

      return {
        ...state,
        token: stored.token,
        refreshToken: stored.token ? stored.refreshToken : null,
        userName: stored.userName,
        role: stored.role,
        publicId: stored.publicId,
        status: stored.status,
      };
    }),
  ),
});
